import React, { useState } from 'react';
import axios from 'axios';

function Login({ onLoginSuccess, onSwitchToSignup }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);

  const handleLogin = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/login', {
        email,
        password,
      });
      setMessage('Login successful! Role: ' + response.data.role);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('role', response.data.role);
      onLoginSuccess(email, response.data.role);
    } catch (error) {
      console.log("vvvvvvvvvvvvvvv ", message)
      setMessage(error.response?.data?.message || 'Login failed');
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setMessage('Please enter your email address.');
      return;
    }

    // Domain validation
    if (!email.toLowerCase().endsWith('@casagrand.co.in')) {
      setMessage('Email must be from @casagrand.co.in domain.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/auth/forgot-password', {
        email,
      });
      setMessage(response.data.message);
      setIsEmailSent(true);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to send reset link');
      setIsEmailSent(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (showForgotPassword) {
        if (!isEmailSent) {
          handleForgotPassword();
        }
      } else {
        handleLogin();
      }
    }
  };

  if (showForgotPassword) {
    return (
      <div className="auth-form">
        <h3 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#374151' }}>
          Reset Password
        </h3>
        <p style={{ textAlign: 'center', marginBottom: '1rem', color: '#666', fontSize: '0.9rem' }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <div className="form-group">
          <label className="form-label">Email ID</label>
          <input
            type="email"
            className="form-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isLoading || isEmailSent}
          />
        </div>

        <button
          onClick={handleForgotPassword}
          className="btn btn-primary w-100P"
          disabled={isLoading || isEmailSent}
        >
          {isLoading ? 'Sending...' : (isEmailSent ? 'Link Sent' : 'Send Reset Link')}
        </button>

        <div className="switch-text">
          <button onClick={() => { setShowForgotPassword(false); setMessage(''); setIsEmailSent(false); }} className="btn-link">
            Back to Login
          </button>
        </div>

        {message && (
          <div className={`message ${message.includes('failed') || message.includes('error') ? 'error' : 'success'}`} style={{ position: 'relative', marginTop: '1rem' }}>
            {message}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="auth-form">
      {/* <div className="login-header">
        <h3 style={{ 
          textAlign: 'center', 
          marginBottom: '1.5rem', 
          color: '#374151', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '0.5rem',
          fontSize: '1.2rem',
          fontWeight: '600'
        }}>
          🔐 Login
        </h3>
      </div> */}

      <div className="form-group">
        <label className="form-label">Email ID</label>
        <input
          type="email"
          className="form-input"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>

      <div className="form-group">
        <label className="form-label">Password</label>
        <div className="password-input-container">
          <input
            type={showPassword ? "text" : "password"}
            className="form-input"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? '👁️' : '👁️‍🗨️'}
          </button>
        </div>
        <div style={{ textAlign: 'right', marginTop: '0.25rem' }}>
          <button
            type="button"
            onClick={() => { setShowForgotPassword(true); setMessage(''); }}
            className="btn-link"
            style={{ fontSize: '0.8rem' }}
          >
            Forgot Password?
          </button>
        </div>
      </div>

      <button onClick={handleLogin} className="btn btn-primary w-100P">
        Login
      </button>

      <div className="switch-text">
        Don't have an account? <button onClick={onSwitchToSignup} className="btn-link">Sign Up</button>
      </div>

      {message && (
        <div className={`message ${message.includes('failed') || message.includes('Incorrect') || message.includes('error') ? 'error' : 'success'}`} style={{ position: 'relative', marginTop: '1rem' }}>
          {message}
        </div>
      )}
    </div>
  );
}

export default Login;